export default "__VITE_ASSET__C0D2lA8F__"